module.exports = __webpack_public_path__ + "static/media/grip-lines.dd7dfa35.svg";